export default __webpack_public_path__ + "static/media/1479.27849096.png";